export type Destination = string;

export interface DestinationItem {
  id: string;
  name: string;
  isProtected?: boolean;
}

export type Category = string;

export interface CategoryItem {
  id: string;
  name: string;
}

export type Person = string;

export interface ResponsibleItem {
  id: string;
  name: string;
  isProtected?: boolean;
}

export interface Transaction {
  id?: number;
  category: Category;
  responsible: Person;
  description: string;
  destination: Destination;
  amount: number;
}

export enum ContributionCalculationType {
  INCOME_RATIO = 'INCOME_RATIO', // Current approach - ratio based on total income
  EQUAL_SPLIT = 'EQUAL_SPLIT', // Each responsible pays an equal part
  AFTER_PERSONAL = 'AFTER_PERSONAL', // Ratio applied after removing personal expenses
  FULL_BALANCE = 'FULL_BALANCE', // Complete balance after personal expenses goes to common
}

export interface BudgetSettings {
  contributionCalculationType: ContributionCalculationType;
  /** ISO 4217 currency code, e.g. 'EUR', 'USD' */
  currency: string;
}

export interface Budget {
  id?: number;
  name: string;
  date: Date;
  transactions: Transaction[];
  isDefault?: boolean;
  categories: CategoryItem[];
  responsibles: ResponsibleItem[];
  destinations: DestinationItem[];
  settings: BudgetSettings;
}

export interface BudgetSummary {
  totalIncome: number;
  totalExpenses: number;
  balance: number;
  personContributions: Record<
    Person,
    {
      income: number;
      expenses: number;
      balance: number;
      contribution: number;
      availableBalance: number;
    }
  >;
}
